import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../../layouts/Header";
import { useCart } from '../../../context/CartContext';
import {getProduct, makeFavorite} from "../api/ProductsAPI";
import {BiInfoCircle, BiSolidCubeAlt} from "react-icons/bi";
import {GiTwoCoins} from "react-icons/gi";
import {TbMessage2, TbSquareRoundedMinus, TbSquareRoundedPlusFilled, TbStarFilled} from "react-icons/tb";

import ProductSlideShow from "./ProductSlideShow";
import Loading from "../../../layouts/Loading";
import {showError, showSuccess} from "../../../utils/toastHelper";
import {GrCatalog, GrShareOption} from "react-icons/gr";
import {ImDownload, ImPlay} from "react-icons/im";
import {IoBarcodeOutline, IoBookmarks, IoBookmarksOutline} from "react-icons/io5";
import {LiaUserCircle} from "react-icons/lia";
import ProductRatingStars from "./ProductRatingStars";
import {LuMessageSquareReply} from "react-icons/lu";


const currencyFormat = Intl.NumberFormat('en-US');
const Reviews = () => {
    const [product, setProduct] = React.useState([]);

    const {id} = useParams();
    const [loading, setLoading] = useState(true);


    const navigate = useNavigate();

    useEffect(() => {

        const fetchProducts = async () => {
            try {
                const params = {
                    vendor: 1,
                }
                const  data = await getProduct(id, params);
                setProduct(data?.data || []);

                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 1000)
            } catch (err) {
                 showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);




    if (loading) return <Loading />;
    return (
        <React.Fragment>
            <Header hasBack={true} transparent={false} title={'نظرات ' + product.name}/>

            <section className="container mt-5 pt-3">
                {
                    product?.reviews?.reviews.map (review => {

                        return (
                            <div className="row my-2 product-search-card  mx-2 pt-2 px-0 " key={review.id}>

                                <div className="col-12 fw-bold text-muted text-big-2">
                                    <LiaUserCircle className='ms-2 text-big-3' />
                                    {review.user}
                                </div>
                                <div className='col-12 mt-2 text-justify'>
                                    {review.comment}
                                </div>
                                <div className="col-6 text-small-2 text-end mt-3">
                                    {review.date}
                                </div>
                                <div className="col-6 mt-2 text-start text-big-1">
                                    <ProductRatingStars rating={review.rate} color='gold' />
                                </div>

                                {
                                    review.reply &&
                                    <div className='col-12 mt-3 text-justify '>

                                        <div className='bg-light p-3 text-small-1 rounded border'>
                                            <span className='mb-2'>
                                                <LuMessageSquareReply className='ms-2 text-big-2' />
                                        </span>
                                            {review.reply}
                                        </div>

                                    </div>
                                }

                            </div>
                        )

                    })
                }
            </section>


        </React.Fragment>
    );
};

export default Reviews;